import React from "react";
import { MailCheck, Calendar } from "lucide-react";

const CheckEmail = () => {
  return (
    <div style={{ minHeight: "100vh", display: "flex", background: "#0b0c10" }}>
      <div style={{ flex: 1, display: "none", position: "relative" }} className="lg:flex">
        <div style={{ position: "absolute", inset: 0, background: "radial-gradient(1200px 600px at -10% 10%, rgba(0, 212, 255, 0.18), transparent 40%), radial-gradient(800px 400px at 110% 80%, rgba(0, 212, 255, 0.12), transparent 40%)" }} />
        <div style={{ position: "relative", zIndex: 1, height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", padding: "64px", color: "#e6f7ff" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
            <Calendar size={28} color="#00d4ff" />
            <h1 style={{ fontSize: 28, fontWeight: 700, letterSpacing: 0.3 }}>Kago Events</h1>
          </div>
          <p style={{ opacity: 0.8, maxWidth: 520, lineHeight: 1.6 }}>
            Create memorable experiences. Manage conferences, webinars and exhibitions with ease.
          </p>
        </div>
      </div>

      <div style={{ width: "100%", maxWidth: 560, margin: "0 auto", display: "flex", alignItems: "center", padding: "48px 24px" }}>
        <div style={{ width: "100%", background: "#0f1115", border: "1px solid rgba(255,255,255,0.06)", borderRadius: 16, boxShadow: "0 10px 30px rgba(0,0,0,0.4)", padding: 32 }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
            <div style={{ width: 72, height: 72, borderRadius: 999, background: "linear-gradient(135deg, rgba(0,212,255,0.2), rgba(0,212,255,0.08))", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
              <MailCheck size={34} color="#00d4ff" />
            </div>
            <h2 style={{ color: "#e6f7ff", fontSize: 26, fontWeight: 700, marginBottom: 8 }}>Verify your email</h2>
            <p style={{ color: "#a9b8c0", fontSize: 14, lineHeight: 1.8 }}>
              We’ve sent a verification link to your email. Please open the email and click the link to activate your account.
            </p>
          </div>

          <div style={{ marginTop: 24, background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)", borderRadius: 12, padding: 16 }}>
            <ul style={{ color: "#b8c7ce", fontSize: 13, lineHeight: 1.8, margin: 0, paddingLeft: 18 }}>
              <li>It may take a minute to arrive.</li>
              <li>Check your spam or junk folder.</li>
              <li>Didn’t get the email? Try resending from the login page.</li>
            </ul>
          </div>

          <div style={{ display: "flex", gap: 12, marginTop: 28, justifyContent: "center" }}>
            <a href="/login" style={{ textDecoration: "none", borderRadius: 10, padding: "10px 16px", border: "1px solid rgba(255,255,255,0.12)", color: "#e6f7ff" }}>
              Go to Login
            </a>
            <a href="/request-demo" style={{ textDecoration: "none", borderRadius: 10, padding: "10px 16px", background: "#00d4ff", color: "#001219", fontWeight: 600 }}>
              Explore Kago
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckEmail;


